module.exports = __webpack_public_path__ + "img/index-partners-banner-4.b9c5155b.jpg";